<template>
  <div>
    <v-container fluid>
      <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
        <v-row no-gutters>
          <v-col cols="12" lg="4" class="my-0 py-0">
            <div class="d-flex grow flex-wrap">
              <div class="ml-2">
                <div class="font-weight-regular headline text-decoration-underline text-capitalize">
                  {{`Ticket : ${ticketingActivity && ticketingActivity.issuecode ? ticketingActivity.issuecode : '-'}`}}
                </div>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-card-actions>
          <router-link
            :to="{ name: 'beesTicketList', params: { ticketstatus: 'open', franchiseeID: '' } }">
            <v-btn text small v-if="$vuetify.breakpoint.smAndUp" absolute right top>
              <v-icon left>mdi-chevron-left</v-icon>back to list
            </v-btn>
            <v-btn v-else fixed right fab small color="grey lighten-2" elevation="1"
              class="mr-n2 mt-10" style="opacity:.6;">
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </router-link>
        </v-card-actions>
        <v-row>
          <v-col cols="12" lg="4">
            <v-card rounded="lg" outlined height="100%">
              <v-banner double-line>
                <span
                  class="title">{{ ticketingActivity && ticketingActivity.franchiseename? ticketingActivity.franchiseename : '-' }}</span>
              </v-banner>
              <v-row>
                <v-col cols="7" class="pb-0 mb-0">
                  <v-card-subtitle class="font-weight-medium black--text"><span
                      class="body-1">Current Status: <span
                        class="primary--text text-capitalize">{{ ticketingActivity && ticketingActivity.status ? ticketingActivity.status : '-' }}</span></span>
                  </v-card-subtitle>
                </v-col>
                <v-col v-if="ticketingActivity.isAssignedUserLogin" cols="5">
                  <v-btn outlined class="mt-4" small v-if="accessFlag" @click="toChangeStatus()"
                    dark color="pink" elevation="1">
                    {{ ticketingActivity.status === 'closed' ? 'Re-Open Ticket' : 'Close Ticket' }}
                  </v-btn>
                </v-col>
              </v-row>
              <v-card-subtitle class="font-weight-medium black--text">
                <span class="body-1">Priority :
                  <span
                    :class="getColor(ticketingActivity && ticketingActivity.priority ? ticketingActivity.priority || '-' : '-')"
                  >
                    {{ ticketingActivity && ticketingActivity.priority ? ticketingActivity.priority || '-' : '-'}}
                  </span>
                </span>
              </v-card-subtitle>
              <v-card-subtitle class="font-weight-medium black--text">
                <span class="body-1">Created By :</span>
                <span class="ml-1">
                  {{ ticketingActivity && ticketingActivity.createdby ? ticketingActivity.createdby : '-' }}
                </span>
              </v-card-subtitle>
              <!-- <v-card-subtitle class="font-weight-medium black--text pb-0 mb-0">
                <span class="body-1">Date : </span>
                <span class="ml-1">
                  {{ ticketingActivity && ticketingActivity.createddate ? ticketingActivity.createddate : 'NA' }}
                </span>
              </v-card-subtitle> -->
              <v-row>
                <v-col cols="6" class="pb-0 mb-0">
                  <v-card-subtitle class="font-weight-medium black--text">
                    <span class="body-1">Assigned To :</span>
                  </v-card-subtitle>
                </v-col>
              </v-row>
              <div class="pa-3"><span v-if="ticketingActivity.assignedto">
                  <span v-if="ticketingActivity.assignedto"
                    class="ml-1 font-weight-medium black--text">
                    {{ ticketingActivity.assignedto }}
                    <div>
                      <span>&#60;</span>
                      {{ticketingActivity && ticketingActivity.assigneemailid ? ticketingActivity.assigneemailid : '-' }}
                      <span>&#62;</span>
                    </div>
                  </span>
                </span></div>
              <v-divider class="py-0 my-0"></v-divider>
              <v-card-subtitle class="font-weight-medium black--text"><span class="body-1">Subject
                  :</span>
                <span
                  class="ml-1">{{ ticketingActivity && ticketingActivity.issuename ? ticketingActivity.issuename : '-' }}</span>
              </v-card-subtitle>
              <v-row>
                <v-col v-if="!isFranchiseeUser" cols="12" class="py-0 d-flex justify-end">
                  <v-btn outlined v-if="accessFlag && ticketingActivity.status !== 'closed'" right @click="toggleModal()" class="px-2 ml-1 ma-1"
                    color="primary" small>
                    Reassign Ticket
                  </v-btn>
                </v-col>
                <v-col cols="12" class="py-0">
                  <v-card-subtitle class="font-weight-medium black--text pt-0"><span class="body-1">Query
                    Related:</span>
                    <span class="ml-1">
                      {{ ticketingActivity && ticketingActivity.queryrelatedtodeptname ? ticketingActivity.queryrelatedtodeptname : '-' }}</span>
                  </v-card-subtitle>
                </v-col>
              </v-row>
              <v-card-subtitle class="font-weight-medium black--text"><span class="body-1">Query
                  Type:</span>
                <span class="ml-1">
                  {{ ticketingActivity && ticketingActivity.querytypename ? ticketingActivity.querytypename : '-' }}</span>
              </v-card-subtitle>
              <v-card-subtitle class="font-weight-medium black--text"><span
                  class="body-1 mr-3">Attachment:</span>
                <template
                  v-if="ticketingActivity && ticketingActivity.attachment && ticketingActivity.attachment.length > 0">
                  <span v-for="(attachement,index) in ticketingActivity.attachment" :key="index">
                    <v-btn @click="downloadFile(attachement)" outlined class="px-2 ml-1 ma-1"
                      min-width="0" small color="primary">
                      <v-icon small>mdi-download</v-icon>
                    </v-btn>
                  </span>
                </template>
                <template v-else>
                  <span class="font-weight-medium black--text">Not Available</span>
                </template>
              </v-card-subtitle>
              <v-divider class="py-0 my-0"></v-divider>
              <v-card-subtitle class="font-weight-medium black--text"><span
                  class="font-weight-regular">
                  <div class="body-1">Description :</div>
                </span>
                {{ ticketingActivity && ticketingActivity.scenario ? ticketingActivity.scenario : '-' }}
              </v-card-subtitle>
              <div v-if="ticketingActivity && ticketingActivity.franchiseDetails">
                <v-divider class="py-0 my-0" ></v-divider>
                <v-card-subtitle class="font-weight-medium black--text">
                  <span class="font-weight-regular">
                    <div class="body-1">Franchisee Contact Info :</div>
                  </span>
                  <span>Email: {{ ticketingActivity.franchiseDetails.franchiseeEmail }}</span></br>
                  <span>Phone: {{ ticketingActivity.franchiseDetails.franchiseeMobileno }}</span></br>
                  <span>Address: {{ ticketingActivity.franchiseDetails.franchiseeAddress }}</span></br>
                  <span>Website: {{ ticketingActivity.franchiseDetails?.website || 'Not available' }}</span></br>
              </v-card-subtitle>
              </div>
            </v-card>
          </v-col>
          <v-col cols="12" lg="8">
            <ticket-summary :ticketObj="ticketingActivity" @download="downloadFile" :ticketID="id"/>
          </v-col>
        </v-row>
      </v-card>
      <v-dialog persistent v-model="enableModal" max-width="650">
        <form @submit.prevent="UpdateSave">
          <v-card>
            <v-toolbar class="white--text" elevation="0" color="accent">
              <v-toolbar-title> Edit </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-toolbar-items>
                <v-btn icon dark @click="toggleModal, clearAll()">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
              <v-row>
                <v-col cols="12" md="6" lg="6">
                  <label class="font-weight-medium body-2">
                    Query Releated To <span class="error--text">*</span>
                  </label>
                  <v-autocomplete
                    :items="queryRelatedToInfo"
                    v-model="queryRelatedToID"
                    item-text="label"
                    item-value="id"
                    placeholder="Query Releated To"
                    hide-details
                    class="pt-0 mt-2"
                    @change="queryTypeID=null, getQueryTypeList()"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="6" lg="6">
                  <label class="font-weight-medium body-2">
                    Query Type <span class="error--text">*</span>
                  </label>
                  <v-autocomplete
                    :items="queryTypeInfo"
                    v-model="queryTypeID"
                    item-text="label"
                    item-value="id"
                    placeholder="Query Type"
                    hide-details
                    class="pt-0 mt-2"
                    required
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" md="12" lg="12">
                  <label class="font-weight-medium body-2">
                    Reason
                  </label>
                  <v-textarea
                    placeholder="Reason for reassign the ticket."
                    v-model="modelReasonForReassign"
                    hide-details
                    class="pt-0 mt-2"
                    auto-grow
                    rows="2"
                  ></v-textarea>
                </v-col>
                <v-col cols="12">
                  <v-card-actions class="justify-end">
                    <v-btn color="accent" type="submit">Save</v-btn>
                  </v-card-actions>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </form>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
import TicketSummary from '@/components/TicketingBees/ticketComponent/ticketSummary'
import Utils from '@/utils'
import constants from '@/utils/constants'
import moment from 'moment'
import stores from '../../stores'
export default {
  props: ['id'],
  components: {
    TicketSummary
  },
  data () {
    return {
      loading: true,
      isLoading: false,
      dropFilesModal: [],
      comment: '',
      selectedAssigneeID: '',
      dropFiles: [],
      loadingComponent: null,
      ticketers: [],
      assigneeres: [],
      subjectData: [],
      paginated: false,
      description: '',
      defaultSortDirection: 'desc',
      total: '',
      assigneeData: [],
      allAssigneeData: [],
      filePath: '',
      filePath1: '',
      uploadPercent: null,
      sizeInMB: '',
      sizeInMB2: '',
      ticketingActivity: {},
      data: [],
      ActivityID: '',
      TicketID1: '',
      readonlyflag: false,
      accessFlag: false,
      closeFlag: false,
      loaderflag: false,
      enableModal: false,
      queryRelatedToID: null,
      queryRelatedToInfo: [],
      queryTypeID: null,
      queryTypeInfo: [],
      getFrnachID: '',
      modules: {
        TicketUpdate: false
      },
      componentName: null,
      componentType: '',
      vendorcode: null,
      modelReasonForReassign: null,
      isFranchiseeUser: false,
      franchiseeFilter: false
    }
  },
  async created () {
    const data = sessionStorage.getItem('franchiseeFilter')
    if (data && data !== 'undefined') {
      this.franchiseeFilter = data
    } else {
      this.franchiseeFilter = false
    }
    this.isFranchiseeUser = stores.user.me.isFranchiseeUser
    this.modules.TicketUpdate = this.checkModuleAccess('TicketUpdate')
    await this.OnStart()
  },
  methods: {
    checkModuleAccess: function (moduleName) {
      return Utils.helper.checkAccessByModule(this.$route, moduleName)
    },
    getColor (name) {
      if (name === 'High') return 'v-error font-weight-bold'
      else if (name === 'Low') return 'v-success font-weight-bold'
    },
    OnStart: async function () {
      await this.getActivityListInfo()
      if (this.queryRelatedToID) {
        await this.getQueryRelatedList()
      }
    },
    getActivityListInfo: async function () {
      try {
        if (!this.loaderflag) {
          this.isLoading = true
        }
        let payload = {}
        payload.ticketID = parseInt(this.id)
        payload.franchiseeFilter = this.franchiseeFilter
        const res = await http.post(`${constants.API_URL}/api/sbTicketing/getTicket`, payload)
        if (res.status === 200 && res.data.status) {
          this.ticketingActivity = res.data.data[0]
          if (this.ticketingActivity && this.ticketingActivity.assigneemailid) {
            this.ticketingActivity.isAssignedUserLogin = (this.ticketingActivity.assigneemailid === stores.user.me.email)
          }
          this.ticketingActivity.createddate = this.ticketingActivity.createddate ? moment(this.ticketingActivity.createddate, 'YYYY-MM-DDThh:mm:ss').format('MMMM Do YYYY, LTS') : ''
          this.ticketingActivity.attachment = (this.ticketingActivity.attachment && this.ticketingActivity.attachment.data) ? this.ticketingActivity.attachment.data : []
          this.accessFlag = this.ticketingActivity.assignedTo || stores.user.me.id
          this.closeFlag = this.ticketingActivity.status === 'closed'
          this.queryRelatedToID = parseInt(this.ticketingActivity.queryrelatedtodeptid)
          this.queryTypeID = parseInt(this.ticketingActivity.querytypeid)
          this.getFrnachID = this.ticketingActivity.franchiseeID
          this.vendorcode = this.ticketingActivity.vendorcode
        } else {
          return this.$dialog.error({
            title: 'Error',
            text: res.data.msg
          })
        }
        this.isLoading = false
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      } finally {
        if (!this.loaderflag) {
          this.isLoading = false
        }
      }
    },
    toChangeStatus: async function () {
      this.$dialog.confirm({
        title: 'Update Ticket Status',
        text: `Do you want to <strong>${this.ticketingActivity ? (this.ticketingActivity.status === 'open' ? 'Closed' : 'Open') : 'NA'}</strong> this ticket`,
        actions: {
          false: {
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                let formData = new FormData()
                formData.append('issueid', parseInt(this.id))
                formData.append('issuecode', this.ticketingActivity.issuecode)
                formData.append('issuename', this.ticketingActivity.issuename)
                formData.append('description', this.ticketingActivity.scenario)
                formData.append('priority', this.ticketingActivity.priority)
                formData.append('allotedto', parseInt(this.ticketingActivity.assignedtoid))
                formData.append('lastmodifiedby', this.ticketingActivity.lastmodifiedby)
                formData.append('queryRelatedTo', parseInt(this.ticketingActivity.queryrelatedtodeptid))
                formData.append('queryType', parseInt(this.ticketingActivity.querytypeid))
                formData.append('comment', 'Status Closed.')
                formData.append('status', this.ticketingActivity.status === 'open' ? 'closed' : 'open')
                formData.append('franchiseeName', this.vendorcode)
                let res = await http.post(`${constants.API_URL}/api/sbTicketing/updateTicket`, formData)
                if (res.status === 200) {
                  if (res.data.status) {
                    this.$dialog.info({
                      text: res.data.msg,
                      title: 'Success'
                    })
                    this.OnStart()
                  }
                }
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              }
            }
          }
        }
      })
    },
    downloadFile: async function (urlObj) {
      try {
        let payload = {}
        payload.links = []
        payload.links.push(urlObj.link)
        const res = await http.post(`${constants.API_URL}/api/sbTicketing/downloadDocument`, payload)
        if (res.status === 200) {
          if (res.data.status) {
            window.open(res.data.data[0].presignurl)
          } else {
            return this.$dialog.error({
              text: res.data.msg,
              title: 'Error'
            })
          }
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        return this.$dialog.error({
          text: errorMessage,
          title: 'Error'
        })
      }
    },
    closeDialog: function () {
      this.enableModal = false
    },
    okMsg (msg) {
      return this.$dialog.info({
        title: 'Success',
        text: msg
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    },
    toggleModal: async function () {
      this.modelReasonForReassign = null
      this.queryRelatedToID = null
      this.queryTypeID = null
      this.modelReasonForReassign = null
      this.enableModal = !this.enableModal
    },
    UpdateSave: async function () {
      this.$dialog.confirm({
        title: 'Reassign Ticket',
        text: `Do you want to reassign this ticket`,
        actions: {
          false: {
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              try {
                let formData = new FormData()
                formData.append('issueid', parseInt(this.id))
                formData.append('issuecode', this.ticketingActivity.issuecode)
                formData.append('issuename', this.ticketingActivity.issuename)
                formData.append('description', this.ticketingActivity.scenario)
                formData.append('priority', this.ticketingActivity.priority)
                formData.append('queryRelatedTo', parseInt(this.queryRelatedToID))
                formData.append('queryType', parseInt(this.queryTypeID))
                formData.append('comment', this.modelReasonForReassign)
                formData.append('status', this.ticketingActivity.status)
                formData.append('franchiseeName', this.vendorcode)
                formData.append('zoneName', this.ticketingActivity.zonename)
                let res = await http.post(`${constants.API_URL}/api/sbTicketing/updateQueryTicket`, formData)
                if (res.status === 200) {
                  if (res.data.status) {
                    this.$dialog.info({
                      text: res.data.msg,
                      title: 'Success'
                    })
                    this.OnStart()
                    this.enableModal = !this.enableModal
                  }
                }
              } catch (e) {
                const errorMessage = (e && e.response && e.response.data.message) || e.message
                this.errMsg(errorMessage)
              }
            }
          }
        }
      })
    },
    clearAll: function () {
      this.enableModal = !this.enableModal
      this.modelReasonForReassign = null
    },
    getQueryRelatedList: async function () {
      try {
        let queryParam = {}
        const res = await http.post(`${constants.API_URL}/api/sbTicketing/getQueryRelatedToList`, queryParam)
        if (res.status === 200) {
          this.queryRelatedToInfo = res.data.QueryRelatedTo.data
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      }
    },
    getQueryTypeList: async function () {
      if (this.queryRelatedToID) {
        try {
          let payload = {}
          payload.projectmoduleid = parseInt(this.queryRelatedToID)
          const res = await http.post(`${constants.API_URL}/api/sbTicketing/getQueryTypeList`, payload)
          if (res.status === 200) {
            if (res.data.status) {
              this.queryTypeInfo = res.data.data
            } else {
              this.errMsg(res.data.msg)
            }
          }
        } catch (e) {
          const errorMessage = (e && e.response && e.response.data.message) || e.message
          this.errMsg(errorMessage)
        }
      } else {
        this.queryTypeInfo = []
      }
    }
  }
}
</script>
<style lang="css">
table {
  width: 100%;
}
.simple td,
.simple th {
  text-align: left;
  padding: 5px 10px;
  border: 1px solid rgba(0, 0, 0, 0.2);
}

.colouredCard {
  background: #f2f2f2 !important;
}

@media screen and (max-width: 670px) {
  .overflowed {
    overflow-x: scroll !important;
  }
}

.commentsSroll {
  overflow-y: scroll !important;
  height: 535px;
}

#chiptxt {
  display: inline-block;
    width: 180px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}
#chiptxt2{
  display: inline-block;
    width: 180px;
    white-space: nowrap;
    overflow: hidden !important;
    text-overflow: ellipsis;
}
</style>
